var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 12a7 7 0 0 0-7 7v2.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V19a7 7 0 0 0-7-7Z"
})));
export default SvgPerson;